/* global I18n */

import React, {useState} from "react"
import FaIcon from "components/fa_icon"
import LearnableProgressBox from "./learnable_progress_box"
import StudySummaryModal from "./study_summary_modal"
import LearningLevelKeys from "./learning_level_keys"

function LearningProgress({
  learnables,
  average_knowledge_change
}) {
  const [summary_modal_is_open, set_summary_modal_is_open] = useState(false)
  const learnables_to_show = learnables.slice(0, 5)
  const hidden_learnables_count = learnables.length - 5

  return (
    <div>
      <div className="detailed-learning-progress-title">
        <div className="title">
          {I18n.t("js.new_embedded_quiz.study_summary.detailed_progress")}
        </div>
        <LearningLevelKeys/>
      </div>
      <div className="learnables-list">
        {learnables_to_show.map((learnable) => (
          <LearnableProgressBox key={learnable.slug} learnable={learnable}/>
        ))}
        {learnables.length > 5 &&
          <button className="more-btn"
                  onClick={() => set_summary_modal_is_open(true)}>
            {I18n.t("js.new_embedded_quiz.study_summary.view_x_more",
              {number: hidden_learnables_count})}
            <FaIcon name={"fa-arrow-right"} />
          </button>}
      </div>
      <StudySummaryModal
        on_close={() => set_summary_modal_is_open(false)}
        is_open={summary_modal_is_open}
        learnables={learnables}
        average_knowledge_change={average_knowledge_change}
      />
    </div>
  )
}

export default LearningProgress
